<template>
    <div v-if="model" class="gerenciamento-diario">
        <rkm-row>
            <rkm-col cols="12">
                <rkm-alert
                    v-if="additionals.possuiAtendimentoRetroativoNaoFinalizado"
                    color="warning"
                >
                    O local de atendimento possui atendimento(s) retroativo(s) não finalizado(s).
                </rkm-alert>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-date-picker
                    :max-date="additionals.dataAtual"
                    :validations="validations.data"
                    label="Data"
                    v-model="model.data"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-input
                    :value="model.agendamentos.length"
                    disabled
                    label="Total de pacientes agendados"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-input
                    :value="model.agendamentos.filter(agendamento => agendamento.statusId === enums.agendamentoStatus.FALTA_DO_PACIENTE && others.moment(agendamento.data).format('DD/MM/YYYY') === additionals.dataAtual).length"
                    disabled
                    label="Total de faltas no dia"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-input
                    :value="model.atendidosEvadidos.filter(atendimento => !atendimento.evadido).length"
                    disabled
                    label="Total de pacientes atendidos no dia"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-input
                    :value="model.atendimentos.filter(atendimento => atendimento.filaStatusId === enums.status.EM_ATENDIMENTO).length"
                    disabled
                    label="Total de pacientes em atendimento"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-input
                    :value="model.atendimentos.filter(atendimento => atendimento.filaStatusId === enums.status.EM_ESPERA).length"
                    disabled
                    label="Total de pacientes aguardando atendimento"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-input
                    :value="model.atendidosEvadidos.filter(atendimento => !!atendimento.evadido).length"
                    disabled
                    label="Total de evasões"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-tabs class="tabela-paciente">
                    <rkm-tab title="Agendamentos">
                        <ListAgendamento
                            :data="{model}"
                            @saved="reloadTabs"
                        />
                    </rkm-tab>

                    <rkm-tab title="Atendimentos">
                        <ListAtendimento
                            :data="{model}"
                            @saved="reloadTabs"
                        />
                    </rkm-tab>

                    <rkm-tab title="Atendidos/Evadidos">
                        <ListEvasao
                            :data="{model}"
                            @saved="reloadTabs"
                        />
                    </rkm-tab>
                </rkm-tabs>
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-3">
            <rkm-col>
                <p class="m-0">
                    <span class="legend-color purple" /> Paciente em óbito<br>
                    <span class="legend-color danger" /> Cadastro bloqueado<br>
                    <span class="legend-color orange" /> Paciente provisório ou temporário<br>
                    <span class="legend-color brown" /> Paciente não munícipe<br>
                    <span class="legend-color warning" /> Paciente sem CPF e CNS<br>
                    <span class="legend-color secondary" /> Falta do paciente
                </p>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Components.
import ListAgendamento from './components/agendamento/List'
import ListAtendimento from './components/atendimento/List'
import ListEvasao from './components/evasao/List'

// Enums.
import agendamentoStatus from '@/enums/ambulatorio/agendamentoStatus'
import status from '@/enums/painel-senha/status'

// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {
        ListAgendamento,
        ListAtendimento,
        ListEvasao,
    },
    computed: {
        validations() {
            return {
                data: {required: true}
            }
        }
    },
    created() {
        this.repositories = {
            gerenciamentoDiario: this.getConectaSusRepository('ambulatorio.gerenciamentoDiario'),
        }
    },
    data: () => ({
        additionals: null,
        enums: {
            agendamentoStatus,
            status,
        },
        model: null,
        others: {moment},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.gerenciamentoDiario.list()
                .then(response => {
                    response.data.model.data = this.others.moment(response.data.model.data, 'DD/MM/YYYY').toDate()

                    this.additionals = Object.assign(response.data.additionals)
                    this.model = Object.assign(response.data.model)

                    this.addWatches()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addWatches() {
            this.$watch('model.data', data => {
                this.model.agendamentos = []
                this.model.atendimentos = []
                this.model.atendidosEvadidos = []

                if (data) {
                    this.reloadTabs()
                }
            })
        },
        reloadTabs() {
            this.setLoading()

            const data = this.others.moment(this.model.data).format('DD/MM/YYYY')

            Promise.all([
                this.repositories.gerenciamentoDiario.list({origem: 'agendamento', data}),
                this.repositories.gerenciamentoDiario.list({origem: 'atendimento', data}),
                this.repositories.gerenciamentoDiario.list({origem: 'atendido-evadido', data}),
            ])
                .then(([
                    responseAgendamentos,
                    responseAtendimentos,
                    responseAtendidosEvadidos
                ]) => {
                    this.model.agendamentos = responseAgendamentos.data.model.agendamentos
                    this.model.atendimentos = responseAtendimentos.data.model.atendimentos
                    this.model.atendidosEvadidos = responseAtendidosEvadidos.data.model.atendidosEvadidos
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [error, repository, stringCase],
    mounted() {
        this.load()
    },
}
</script>

<style scoped>
.legend-color {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 2px;
    margin-right: 4px;
}
.legend-color.purple {
    background-color: #6f42c1;
}
.legend-color.danger {
    background-color: var(--danger);
}
.legend-color.orange {
    background-color: #F28C28;
}
.legend-color.brown {
    background-color: #6F4E37;
}
.legend-color.warning {
    background-color: var(--warning);
}
.legend-color.secondary {
    background-color: var(--secondary);
}

.tabela-paciente >>> .table-orange {
    border-color: #F28C28;
    background-color: #FFE0B2;
}

.tabela-paciente >>> .table-brown {
    border-color: #6F4E37;
    background-color: #D2B48C;
}

.tabela-paciente >>> .table-purple {
    border-color: #6f42c1;
    background-color: #E1D4F2;
}
</style>
